import { SecuredHeader } from './secureHeader';
import { PublicHeader } from './publicHeader';

export const Header = ({ type, ...props }) => {
  if (typeof type === 'undefined') {
    type = 'public';
  }
  switch (type) {
    case 'secured':
      return <SecuredHeader {...props} />;
    case 'public':
      return <PublicHeader {...props} />;
    default:
      return null;
  }
};
